import React from "react";
import { IChartDataIndicators, IChartTableIndicators } from "../ModalIndicatorChart/interface";

async function mountDefaultValueTable(fullDataChart: IChartDataIndicators[], fullDataChartAccumulated: IChartDataIndicators[], setDataTable: (value: React.SetStateAction<IChartTableIndicators[]>) => void, tendencyString: string){
	let newDataTable = fullDataChart && fullDataChart.length > 0 ? fullDataChart[0].values.filter((x) => x.showInTable).map((fullValues) => ({
		name: fullValues.name,
		isTendency: fullValues.isTendency
	})) : [];

	newDataTable = newDataTable.map((names) => ({
		name: names.isTendency ? `${tendencyString} - ${names.name}` : names.name,
		values: fullDataChart.map((fullData) => {
			const val = names.isTendency ? fullData.values.filter((x) => x.showInTable && x.isTendency).find((x) => x.name === names.name) 
				: fullData.values.filter((x) => x.showInTable).find((x) => x.name === names.name);
			return {
				name: names.isTendency ? `${tendencyString} - ${fullData.name}` : fullData.name,
				value: val?.value,
				labelCode: val?.labelCode,
				currentPeriod: val?.currentPeriod,
				fcaAbsent: val?.fcaAbsent,
				hasFca: val?.hasFca,
				showFCAHeader: fullData.hasFCA,
				comment: val?.comment,
				periodId: val?.periodId,
				decimalPlaces: val?.decimalPlaces
			};
		}),
		accumulatedValues: fullDataChartAccumulated !== null && fullDataChartAccumulated.length > 0 ? fullDataChartAccumulated.map((fullData) => {
			const val = names.isTendency ? fullData.values.filter((x) => x.showInTable && x.isTendency).find((x) => x.name === names.name)
				: fullData.values.filter((x) => x.showInTable).find((x) => x.name === names.name);
			return {
				name: names.isTendency ? `${tendencyString} - ${fullData.name}` : fullData.name,
				value: val?.value,
				labelCode: val?.labelCode,
				currentPeriod: val?.currentPeriod,
				fcaAbsent: val?.fcaAbsent,
				hasFca: val?.hasFca,
				showFCAHeader: fullData.hasFCA,
				comment: val?.comment,
				decimalPlaces: val?.decimalPlaces
			};
		}) : undefined,
		isTendency: names.isTendency
	}));

	setDataTable(newDataTable as IChartTableIndicators[]);
}

export default mountDefaultValueTable;
